import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles";
import { AjudaContainer } from "./styles";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { Button } from "../Button";
import { EmpresaContext } from "../../contexts/Empresa/EmpresaContext";
import { Toggle } from "../Toggle/Toggle";
import { PerfilApi } from "../../hooks/perfilApi";
import { ReactComponent as ClubeSVG } from "../../assets/newImages/home/IconeClubeConectado.svg";
import { ReactComponent as WhatsappSVG } from "../../assets/newImages/ajuda/whatsapp.svg";
import { ReactComponent as YoutubeSVG } from "../../assets/newImages/ajuda/youtube.svg";

interface AjudaProps {
  onClose?: () => void;
}

const Ajuda: React.FC<AjudaProps> = ({ onClose }) => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const Perfil = PerfilApi();
  const { empresa, setEmpresa } = useContext(EmpresaContext);
  const [usuarioAtivo, setUsuarioAtivo] = useState(false);

  useEffect(() => {
    Perfil.verificaUsuarioSuporte().then((ativo) => {
      setUsuarioAtivo(ativo === true);
    });
  }, []);

  return (
    <>
      <AjudaContainer theme={theme} demo={empresa?.demo}>
        <div className="titulo fonteTitulo">Precisa de ajuda?</div>
        <div className="texto fonteTexto">Podemos te ajudar, escolha uma opção:</div>
        <div className="botoes fonteTexto">
          <a
            href={`https://api.whatsapp.com/send?phone=555434434563&text=Ol%C3%A1,+tenho+uma+d%C3%BAvida+sobre+o+ConectaVenda.+Meu+usu%C3%A1rio+%C3%A9:+${empresa?.usuario}+da+empresa:+${empresa?.empresa}.`}
            target="_blank"
          >
            <Button
              title="Atendimento via WhatsApp"
              width="100%"
              icon={<WhatsappSVG style={{ width: 18, height: 18 }} />}
            />
          </a>
          <Button
            title="Clube conectado"
            width="100%"
            icon={<ClubeSVG style={{ width: 21, height: 18, fill: "#fff" }} />}
            onClick={() => {
              onClose && onClose();
              navigate("/clube-conectado");
            }}
          />
          <a
            href="https://www.youtube.com/channel/UC_hQtVZCfjkOfLMJLeeq74A"
            target="_blank"
          >
            <Button
              title="Vídeos do Youtube"
              width="100%"
              icon={<YoutubeSVG style={{ width: 18, height: 18 }} />}
            />
          </a>
        </div>
        <div className="suporte">
          <div className="toggle">
            <Toggle
              value={usuarioAtivo}
              onChange={() => {
                if (usuarioAtivo) {
                  Perfil.desabilitarUsuarioSuporte().then(() => {
                    setUsuarioAtivo(false);
                  });
                } else {
                  Perfil.habilitarUsuarioSuporte().then(() => {
                    setUsuarioAtivo(true);
                  });
                }
              }}
            />
          </div>
          <div className="fonteTexto">
            Usuário de suporte
            <br />
            <span className="fonteRotulos">Libere acesso aos nossos especialistas</span>
          </div>
          {/*        <span>Usuário de atendimento</span> <br />
          <span>Libere acesso aos nossos especialistas</span> */}
        </div>
        <div className="titulo fonteSubtitulo">Acompanhe nosso Instagram</div>
        <div className="texto fonteTexto">
          <a href="https://www.instagram.com/conectavenda/" target="_blank">
            @conectavenda
          </a>
        </div>
      </AjudaContainer>
    </>
  );
};

export default Ajuda;
